// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import Zone from "@insite/client-framework/Components/Zone";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ManagedAccordionSection } from "@insite/mobius/AccordionSection";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { CustomAppState } from "@steiner/App/Store/Reducers";
import { AccordionSectionPresentationProps } from "@steiner/MobiusOverrides/AccordionSection/AccordionSection";
import React, { FC } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: CustomAppState) => ({
    view: state.pages.productList.view,
    isTabletScreen: state.xCommon.isTabletScreen,
    totalItemCount: getProductListDataViewProperty(state, "pagination")?.totalItemCount,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface ProductListColumnsStyles {
    // container?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    leftColumnTableViewGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    rightColumnTableViewGridItem?: GridItemProps;
    // XNG-Changes:
    container?: InjectableCss;
    leftColumnItem?: InjectableCss;
    rightColumnItem?: InjectableCss;
    filtersAccordionItem?: InjectableCss;
    plpAccordion?: AccordionSectionPresentationProps;
}

export const columnsStyles: ProductListColumnsStyles = {
    // container: {
    //     gap: 20,
    // },
    leftColumnGridItem: {
        width: [12, 12, 3, 3, 3],
    },
    leftColumnTableViewGridItem: {
        width: [12, 12, 0, 0, 0],
    },
    rightColumnGridItem: {
        width: [12, 12, 9, 9, 9],
    },
    rightColumnTableViewGridItem: {
        width: 12,
    },
};

const styles = columnsStyles;

const ProductListColumns: FC<Props> = ({ id, view, isTabletScreen, totalItemCount }) => {
    return (
        <StyledWrapper {...styles.container}>
            {/* XNG-Changes: structure change for tablet/mobile */}
            {isTabletScreen && (
                <StyledWrapper {...styles.filtersAccordionItem}>
                    {createWidgetElement("Category/CategoryName", {
                        fields: { showImproveLink: true },
                    })}
                    <ManagedAccordionSection
                        title={translate("Facets Filter")}
                        initialExpanded={false}
                        onTogglePanel={() => {}}
                        {...styles.plpAccordion}
                    >
                        <Zone contentId={id} zoneName="Content00" />
                    </ManagedAccordionSection>
                </StyledWrapper>
            )}
            <StyledWrapper {...styles.leftColumnItem}>
                <Zone contentId={id} zoneName="Content00" />
            </StyledWrapper>
            {/* XNG-Changes */}
            <StyledWrapper {...styles.rightColumnItem}>
                {!isTabletScreen &&
                    createWidgetElement("Category/CategoryName", {
                        fields: { showImproveLink: true },
                    })}
                {createWidgetElement("Category/CategoryDetailBanner", {
                        fields: {
                            showCategoryContent: true,
                            showCategoryImage: false,
                        },
                    })}
                <Zone contentId={id} zoneName="Content01" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ProductListColumns),
    definition: {
        group: "Product List",
        displayName: "Columns",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
